const listeners = new Set<() => void>();

export function subscribeToModalVisibility(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function notifyModalVisibility(): void {
  listeners.forEach((listener) => listener());
}
